module.exports = __webpack_public_path__ + "assets/21641a11858547e863d132ca9bf4f7a4.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-16.eot
// module id = 3629
// module chunks = 0